import m from 'mithril'

export default {
  view: vnode => {
    return (
      <svg
        class="hotspot-lock-icon"
        viewBox="0 0 28 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className="hotspot-lock-icon-path"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.87895 13.4234V9.9018C3.87895 4.4703 8.28205 0.0671997 13.7135 0.0671997C19.145 0.0671997 23.5481 4.4703 23.5481 9.9018V13.4234H25.5057C26.6126 13.4234 27.51 14.3207 27.51 15.4276V30.063C27.51 31.1699 26.6126 32.0672 25.5057 32.0672H2.00421C0.897313 32.0672 0 31.1699 0 30.063V15.4276C0 14.3207 0.897314 13.4234 2.00421 13.4234H3.87895ZM7.88736 9.9018C7.88736 6.68409 10.4958 4.07562 13.7135 4.07562C16.9313 4.07562 19.5397 6.68409 19.5397 9.9018V13.4234H7.88736V9.9018ZM13.7195 18.8768C14.8264 18.8859 15.7163 19.7905 15.7073 20.8973L15.6763 24.6876C15.6672 25.7944 14.7626 26.6844 13.6557 26.6753C12.5489 26.6663 11.6589 25.7617 11.668 24.6548L11.699 20.8646C11.708 19.7577 12.6126 18.8678 13.7195 18.8768Z"
        />
      </svg>
    )
  }
}
